<template>
    <div id="bottomExplain">
        <span class="lightGray leftSpan">Copyright 2020 cbit | All rights Reserved</span>
        <span class="lightGray centerSpan">中国银行保险信息技术管理有限公司</span>
        <span class="lightGray centerSpan">京ICP备14041146号-4</span>
    </div>
</template>

<script>
    export default {
        name: "if_text"
    }
</script>

<style scoped>
    #bottomExplain{
      background: #FAFAFA;
      text-align: left;
      min-width: 60rem;
      margin: 0 auto;
      padding: 0.417rem 0;
    }
    #bottomExplain .leftSpan{
        /*margin-left: 2.083rem;*/
        margin-left: 5.25rem;
        margin-right: 0.417rem;
    }
    #bottomExplain .centerSpan{
        margin-right:0.417rem;
    }
    .lightGray{
        color: #999999;
        font-size: 0.5rem;
    }

</style>